import React, { useState, useEffect } from "react";
import Sidebar from '../../composant_reutilisable/sidebar';
import Navbar from "../../composant_reutilisable/navbar";
import useAuth from '../../composant_reutilisable/useAuth';
import { Link } from "react-router-dom";
import TableauDynamique from "../../composant_reutilisable/tableau";
import { BsPeople } from "react-icons/bs";
import { Modal, Button, Form } from "react-bootstrap"; // Ajout du modal Bootstrap
import ModalComponent from "../../composant_reutilisable/composant_modal";
import { FaBan, FaCogs, FaEdit, FaPlus, FaQuestionCircle, FaTimes, FaTrash } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import Footer from "../../composant_reutilisable/footer";

const ListeCategorie = () => {
    useAuth();
    const navigate = useNavigate();

    // const utilisateur_id = localStorage.getItem("utilisateur_id");
    const [isLoading, setIsLoading] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const user_id = localStorage.getItem('userId');
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [alertModal, setAlertModal] = useState({ message: '', type: '' });

    const [categories, setCategories] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [categorieSelectionne, setCategorieSelectionne] = useState(null);

    useEffect(() => {
        if (user_id) {
            document.title = "ShowTime | Liste categorie des mots Sensibles";
        }
    }, [user_id]);

    // États pour gérer le modal
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showConfigureModal, setShowConfigureModal] = useState(false);

    const [nouvelleCategorie, setNouvelleCategorie] = useState({ nom: "", description: "" });

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 3000);
    };

    const showAlertModal = (message, type = 'success') => {
        setAlertModal({ message, type });
        setTimeout(() => {
            setAlertModal({ message: '', type: '' });
        }, 5000);
    };

    // Récupération des categories de mots sensibles
    const fetchCategories = async () => {
        try {
            setIsLoading(true);
            const response = await fetch(process.env.REACT_APP_HOTE + "/listes-categorie/");
            if (response.ok) {
                const data = await response.json();
                setCategories(data);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error("Erreur lors de la récupération des catégories de mots sensibles:", error);
        }
    };
    useEffect(() => {
        fetchCategories();
    }, []);

    const colonnesCategories = [
        //{ titre: "Id", cle: "id" },
        { titre: "Nom", cle: "nom" },
        { titre: "Description", cle: "description" },
        // { titre: "Membres", cle: "nombre_utilisateurs" },
    ];

    // Filtrage
    const categoriesFiltres = categories.filter(categorie =>
        categorie?.nom?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        categorie?.description?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Pagination
    const totalItems = categoriesFiltres.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const categoriesAffiches = categoriesFiltres.slice(indexOfFirstItem, indexOfLastItem);

    // Gestion du modal
    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const handleShowConfigureModal = (categorieSelectionne) => {
        setCategorieSelectionne(categorieSelectionne);
        if (!categorieSelectionne) return;
        setShowConfigureModal(true);
    }
    const handleCloseConfigureModal = () => {
        setInputValue("");
        setTags([]);
        setShowConfigureModal(false);
    };

    const handleShowDeleteModal = (categorieSelectionne) => {
        setCategorieSelectionne(categorieSelectionne);
        if (!categorieSelectionne) return;
        setShowDeleteModal(true);
    };
    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    const handleShowEditModal = (categorieSelectionne) => {
        setCategorieSelectionne(categorieSelectionne);
        if (!categorieSelectionne) return;
        setShowEditModal(true);
    };
    const handleCloseEditModal = () => {
        setShowEditModal(false);
    };

    // Gestion du formulaire d'ajout
    const handleChange = (e) => {
        setNouvelleCategorie({ ...nouvelleCategorie, [e.target.name]: e.target.value });
    };
    // Ajouter une catégorie
    const handleAjouterCategorie = async () => {
        if (!nouvelleCategorie.nom.trim()) {
            showAlert("Le nom de la catégorie est obligatoire.", "danger");
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/ajouter-categorie/${user_id}/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(nouvelleCategorie),
            });

            if (response.ok) {
                fetchCategories()
                setNouvelleCategorie({ nom: "", description: "" });
                handleCloseModal();
                showAlert("Catégorie ajoutée avec succès", "success");
            } else {
                showAlert("Erreur lors de l'ajout de la catégorie.", "danger");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
            showAlert("Une erreur est survenue. Veuillez réessayer.", "danger");
        }
    };

    // Supprimer une catégorie
    const handleDeleteCategorie = async () => {
        if (categorieSelectionne) {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/supprimer-categorie/${categorieSelectionne.id}/${user_id}/`, {
                    method: 'DELETE',
                });

                if (response.ok) {
                    setCategories(categories.filter((categorie) => categorie.id !== categorieSelectionne.id));
                    setCategorieSelectionne(null);

                    // Stocker le message de succès dans localStorage
                    showAlert('Catégorie supprimé avec succès !');
                } else {
                    console.error('Erreur lors de la suppression du catégorie');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setShowDeleteModal(false);
            }
        }
    };

    // Modifier une catégorie
    const handleModifierCategorie = async () => {
        if (categorieSelectionne) {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_HOTE}/modifier-categorie/${categorieSelectionne.id}/${user_id}/`,
                    {
                        method: 'PUT', // ou PATCH si tu veux modifier partiellement
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            nom: categorieSelectionne.nom,
                            description: categorieSelectionne.description, // Assure-toi d'envoyer les bonnes données
                        }),
                    }
                );

                if (response.ok) {
                    const updatedCategorie = await response.json();

                    // Mettre à jour la liste des assureurs avec la modification
                    setCategories(categories.map((categorie) =>
                        categorie.id === categorieSelectionne.id ? updatedCategorie : categorie
                    ));

                    showAlert('Categorie modifiée avec succès !');
                } else {
                    console.error('Erreur lors de la modification de categorie');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setShowEditModal(false);
            }
        }
    };

    const colonnesdropdown = [
        {
            label: "Mots sensibles",
            icon: <FaCogs color="green" />,
            actionKey: "configurer",
        },
        {
            label: "Modifier",
            icon: <FaEdit color="blue" />,
            actionKey: "edit",
        },
        {
            label: "Supprimer",
            icon: <FaTrash color="red" />,
            actionKey: "delete",
        },
    ];
    const handleAction = (categorieSelectionne, action) => {
        // console.log("groupe sélectionné :", categorieSelectionne);
        // console.log("Action reçue :", action);
        if (!categorieSelectionne || !action) {
            console.error("Action invalide ou utilisateur non défini");
            return;
        }

        switch (action.actionKey) {
            case "configurer":
                handleShowConfigureModal(categorieSelectionne);
                break;
            case "edit":
                handleShowEditModal(categorieSelectionne);
                break;
            case "delete":
                handleShowDeleteModal(categorieSelectionne);
                break;
            default:
            // console.log("Action inconnue :", action);
        }
    };

    // Gestion du modal d'ajout de mot sensibles par catégorie
    const [tags, setTags] = useState([]);
    const [inputValue, setInputValue] = useState("");

    const addTag = () => {
        const trimmed = inputValue.trim();
        if (trimmed && !tags.includes(trimmed)) {
            setTags([...tags, trimmed]);
            setInputValue("");
        }
    };

    const removeTag = (index) => {
        const newTags = [...tags];
        newTags.splice(index, 1);
        setTags(newTags);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            addTag();
        }
    };

    const [nouveauMot, setNouveauMot] = useState([]);

    const handleAjouterMot = async () => {
        const nomsNonVides = tags
            .map(nom => nom.trim())
            .filter(nom => nom.length > 0);

        if (nomsNonVides.length === 0) {
            showAlert("Veuillez saisir au moins un mot sensible.", "danger");
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/ajouter-mots-sensibles/${user_id}/${categorieSelectionne.id}/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    noms: nomsNonVides,
                    categorie_id: categorieSelectionne.id,  // même si présent dans l’URL, ton backend le lit aussi ici
                }),
            });

            if (response.ok) {
                // await fetchMots();               // recharge la liste des mots
                handleCloseConfigureModal();              // ferme le modal
                showAlert("Mots sensibles ajoutés avec succès", "success");
            } else {
                showAlert("Erreur lors de l'ajout des mots sensibles.", "danger");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
            showAlert("Une erreur est survenue. Veuillez réessayer.", "danger");
        }
    };

    const fetchMotsCategorie = async (categorieSelectionne) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/mots-sensibles/${categorieSelectionne.id}/`);
            if (response.ok) {
                const data = await response.json();
                setTags(data.mots || []);  // 🔁 tu remplaces les tags par ceux de la base
            } else {
                console.error("Erreur de récupération des mots sensibles");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
        }
    };


    useEffect(() => {
        if (showConfigureModal && categorieSelectionne && categorieSelectionne.id) {
            fetchMotsCategorie(categorieSelectionne);
        }
    }, [showConfigureModal, categorieSelectionne]);




    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaBan size={25} className='mr-2' />Gestion des mots sensibles
                                </div>

                                {/* Bouton d'aide complètement à droite */}
                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Manuel d'utilisation"
                                    onClick={() => navigate('/Manuel-utilisation-admin', {
                                        state: {
                                            fromModule: 'administration',
                                            fromSection: 'groupes'
                                        }
                                    })}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                            </h2>
                            <small>Administration des mots sensibles.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        Mots sensibles
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`mt-3 alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}
                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5>Liste des catégories de mots sensibles</h5>
                            <div className="text-right">
                                <button className="btn btn-success mr-2" onClick={handleOpenModal}>
                                    <FaPlus className="mr-1" />Ajouter
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content">
                                        <TableauDynamique
                                            colonnes={colonnesCategories}
                                            donnees={categoriesFiltres}
                                            isLoading={isLoading}
                                            colonnesdropdown={colonnesdropdown}
                                            onAction={handleAction}
                                            messageAucun="Aucune catégorie trouvé."
                                        // onSelectRow={handleSelectionGroupe}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <Footer />

                </div>
            </div>


            {/* Modal de création de categorie */}
            <ModalComponent
                show={showModal}
                handleClose={handleCloseModal}
                title="Créer une Catégorie"
                fields={[
                    { name: "nom", label: "Nom", placeholder: "Nom de la catégorie", required: true },
                    { name: "description", label: "Description", type: "textarea", placeholder: "Description de la catégorie", required: true },

                ]}
                formData={nouvelleCategorie}
                handleChange={handleChange}
                handleSubmit={handleAjouterCategorie}
                submitText="Ajouter"
            />

            {/* Modal de confirmation de suppression */}
            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                <Modal.Header>
                    <Modal.Title>Confirmer la suppression</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Êtes-vous sûr de vouloir supprimer la categorie <strong>{categorieSelectionne?.titre}</strong> ?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteModal}>
                        <strong>Annuler</strong>

                    </Button>
                    <Button variant="success" onClick={handleDeleteCategorie}>
                        <strong>Supprimer</strong>

                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de modification */}
            <Modal show={showEditModal} >
                <Modal.Header >
                    <Modal.Title>Modifier la categorie</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formCategorie">
                            <Form.Label>Nom</Form.Label>
                            <Form.Control
                                type="text"
                                value={categorieSelectionne?.nom || ''}
                                onChange={(e) =>
                                    setCategorieSelectionne({ ...categorieSelectionne, nom: e.target.value })
                                }
                            />
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                type="text"
                                value={categorieSelectionne?.description || ''}
                                onChange={(e) =>
                                    setCategorieSelectionne({ ...categorieSelectionne, description: e.target.value })
                                }
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseEditModal}>
                        <strong>Annuler</strong>
                    </Button>
                    <Button variant="success" onClick={handleModifierCategorie}>
                        <strong>Modifier</strong>
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal d'ajout  */}
            <Modal show={showConfigureModal} onHide={handleCloseConfigureModal}>
                <Modal.Header>
                    <Modal.Title>Enregistrer les mots sensibles</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* <div className="">
                        <label>Mots sensibles </label>
                    </div> */}
                    <div className="">
                        {tags.map((tag, index) => (
                            <span
                                key={index}
                                className="badge rounded bg-light text-dark border me-2 mb-1 mr-1"
                            >
                                {tag}
                                <FaTimes
                                    className="ml-1 ms-2 close-red"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => removeTag(index)}
                                />
                            </span>
                        ))}
                        <input
                            type="text"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyDown={handleKeyDown}
                            // placeholder="Tapez et appuyez sur Entrée"
                            className="border-0 bg-transparent"
                            style={{
                                outline: "none",
                                minWidth: "80px",
                                display: "inline-block"
                            }}
                        />
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseConfigureModal}>
                        <strong>Annuler</strong>
                    </Button>
                    <Button variant="success" onClick={handleAjouterMot}>
                        <strong>Enregistrer</strong>
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
};

export default ListeCategorie;
